export const TILE_COLOURS = {
  disease: {
    background: '#fff5f5',
    border: '#f5c0c0',
    accent: '#d94f4f',
    text: '#b83030',
    subtext: '#c06060'
  },
  phenotype: {
    background: '#f0f9fb',
    border: '#9fd6e2',
    accent: '#2BA9BF',
    text: '#1a7a8f',
    subtext: '#3e9aab'
  },
  genotype: {
    background: '#f7f4fd',
    border: '#c9b5ed',
    accent: '#7546cc',
    text: '#512ea0',
    subtext: '#7555bb'
  }
};
